import React from "react";
import { createRoot, type Root } from "react-dom/client";
import LogoCloudDemo from "@/components/logo-cloud-demo";
import { FaqsSection } from "@/components/ui/faqs-1";

// Mount registry — maps data-react-component values to component classes
const COMPONENTS: Record<string, React.ComponentType<Record<string, unknown>>> = {
  LogoCloudDemo: LogoCloudDemo as React.ComponentType<Record<string, unknown>>,
  FaqsSection: FaqsSection as React.ComponentType<Record<string, unknown>>,
};

const roots = new WeakMap<HTMLElement, Root>();

function mountComponents() {
  const mounts = document.querySelectorAll<HTMLElement>("[data-react-component]");

  mounts.forEach((el) => {
    const name = el.dataset.reactComponent;
    if (!name) return;

    const Component = COMPONENTS[name];
    if (!Component) {
      console.warn(`[react_app] Unknown component: "${name}"`);
      return;
    }

    let props: Record<string, unknown> = {};
    if (el.dataset.reactProps) {
      try {
        props = JSON.parse(el.dataset.reactProps);
      } catch (e) {
        console.error(`[react_app] Failed to parse props for "${name}":`, e);
      }
    }

    let root = roots.get(el);
    if (!root) {
      root = createRoot(el);
      roots.set(el, root);
    }

    root.render(
      <React.StrictMode>
        <Component {...props} />
      </React.StrictMode>
    );
  });
}

// Mount on initial load and after Turbo navigations
document.addEventListener("DOMContentLoaded", mountComponents);
document.addEventListener("turbo:render", mountComponents);
document.addEventListener("turbo:load", mountComponents);
